import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./fuel.scss";
import { fetchVehicle } from "../../store/slices/Vehicle/thunk";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TextField,
  IconButton,
  Chip,
  Button,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { deleteFuel, fetchFuel } from "../../store/slices/thunk";
import { MdDelete } from "react-icons/md";
import ConfirmDialog from "../../components/deleteModal";
import Loader from "../../components/loader";
import AddIcon from '@mui/icons-material/Add';
import { IoSearchOutline } from "react-icons/io5";
import { Navigate,useNavigate } from "react-router-dom";
import { useClientFilter } from "../../Hooks/useClientFilter";
import FilterPopover from "../../components/FilterPopover/FilterPopover";
const FuelList = () => {
  const [search, setSearch] = useState("");
  const dispatch: any = useDispatch();
  const [getAllFuel, setAllFuel] = useState([]);

  const { filteredData, filters, setFilter, clearFilter } = useClientFilter(getAllFuel);
    const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const DEBOUNCE_DELAY = 500; // milliseconds
  const ITEMS_PER_PAGE = 10;
  const pageCount = Math.ceil(totalCount / ITEMS_PER_PAGE);

  const [openDialog, setOpenDialog] = useState(false);
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const handler = setTimeout(async () => {
      setIsLoading(true); // Start loader
      try {
        const response = await dispatch(fetchFuel(page, ITEMS_PER_PAGE, search));
        if (response && response?.data && response?.data?.data && response?.data?.data?.length && response?.isSuccess) {
          setAllFuel(response?.data?.data);
          setTotalCount(response?.data?.totalCount);
        } else {
          setAllFuel([]);
          setTotalCount(0);
        }
      } catch (error) {
        console.log(getAllFuel);
        setAllFuel([]);
        setTotalCount(0);
      } finally {
        setIsLoading(false); // Stop loader
      }
    }, DEBOUNCE_DELAY);
    return () => {
      clearTimeout(handler);
    }
  }
    , [search, page, dispatch]);


  const handleDelete = async (id: string) => {
    const response = await dispatch(deleteFuel(id));
    if (response && response?.isSuccess) {
      const updatedFuel = getAllFuel.filter((item: any) => item._id !== id);
      setAllFuel(updatedFuel);
    }
  }
  const handleDeleteClick = (id: string) => {
    setDeleteId(id);
    setOpenDialog(true);
  };

  const navigateTofuellist = () => {
    navigate("/add-fuel");
  };
  const confirmDelete = async () => {
    if (deleteId) {
      await handleDelete(deleteId);
    }
    setOpenDialog(false);
    setDeleteId(null);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div className="fuel-list d-flex justify-content-between flex-row" style={{ flexShrink: 0 }}>
          <div className="d-flex flex-column">
            <h2 style={{ color: "#0f172a", fontWeight: "700", fontSize: "24px", margin: "0", fontFamily: "sans-serif" }}>
              Fuel Management
            </h2>
            <p style={{ color: "#64748b", fontSize: "14px", margin: "4px 0 0 0", fontWeight: "400" }}>
              Track fuel consumption and expenses
            </p>
          </div>
        <p>
          {" "}
            <button className="px-2 py-2" onClick={navigateTofuellist} style={{background:"#3b82f6", color:"#fff", borderRadius:"10px", height:"auto", width:"auto", border:"none"}}><AddIcon/>Add New Fuel</button>
        </p>
      </div>
      <Paper sx={{ padding: 2, flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
          <div className="search-box align-items-baseline justify-content-start" style={{ flexShrink: 0 }}>
            <div className="search-wrapper">
              <IoSearchOutline className="search-icon" />
              <input
                placeholder="Search Fuel Detail Here"
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
          <TableContainer sx={{ overflowY: "auto", flex: 1, minHeight: 0 }}>
            <Table className="table ">
            <TableHead className="th">
<TableRow className="table-h-row">
  <TableCell
    className="table-cell"
    style={{ color: "#374151", background: "#f9fafb", fontWeight: 500, fontSize: "18px" }}
  >
    S.No
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ color: "#374151", background: "#f9fafb", fontWeight: 500, fontSize: "18px" }}
  >
    Vehicle
    <FilterPopover column="vehicle.vehicleName" filterType="text" currentValue={filters["vehicle.vehicleName"] || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ color: "#374151", background: "#f9fafb", fontWeight: 500, fontSize: "18px" }}
  >
    QTY (Gallons)
    <FilterPopover column="quantity" filterType="text" currentValue={filters.quantity || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ color: "#374151", background: "#f9fafb", fontWeight: 500, fontSize: "18px" }}
  >
    Odometer Reading
    <FilterPopover column="odometerReading" filterType="text" currentValue={filters.odometerReading || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ color: "#374151", background: "#f9fafb", fontWeight: 500, fontSize: "18px" }}
  >
    Amount
    <FilterPopover column="amount" filterType="text" currentValue={filters.amount || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ color: "#374151", background: "#f9fafb", fontWeight: 500, fontSize: "18px" }}
  >
    Date
    <FilterPopover column="fillDate" filterType="date" currentValue={filters.fillDate || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ color: "#374151", background: "#f9fafb", fontWeight: 500, fontSize: "18px" }}
  >
    Comment
    <FilterPopover column="comment" filterType="text" currentValue={filters.comment || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ color: "#374151", background: "#f9fafb", fontWeight: 500, fontSize: "18px" }}
  >
    Action
  </TableCell>
</TableRow>

            </TableHead>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  <Loader />
                </TableCell>
              </TableRow>
            ) : (

              <TableBody className="tb">
                {filteredData.map((item: any, index) => (
                  <TableRow className="t-row" key={index}>
                    <TableCell className="table-cell">{index + 1}</TableCell>
                     <TableCell className="table-cell">
                      {item.vehicle.vehicleName || "--"}
                    </TableCell>
                    <TableCell className="table-cell">
                      {item.quantity || "--"}
                    </TableCell>
                   
                    <TableCell className="table-cell">
                      {item.odometerReading || "--"}
                    </TableCell>
                    <TableCell className="table-cell">
                      {item.amount}
                    </TableCell>
                    <TableCell className="table-cell">
                      {/* {item.driver.driverName || '---'} */}
                       {item.fillDate
                        ? new Date(item.fillDate).toLocaleDateString("en-GB")
                        : "--"}
                    </TableCell>
                    <TableCell className="table-cell">
                      {item.comment || '---'}
                    </TableCell>
                    <TableCell className="table-cell">
                      <IconButton>
                        
                        <MdDelete onClick={() => handleDeleteClick(item._id)} style={{ color: "red" }} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                <ConfirmDialog
                  open={openDialog}
                  onClose={() => setOpenDialog(false)}
                  onConfirm={confirmDelete}
                />

                {filteredData.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No Fuel Found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>
        </div>
        <nav style={{ flexShrink: 0 }}>
          <ul className="pagination justify-content-center">
            <li
              className={`page-item ${page === 1 && "disabled"
                }`}
            >
              <button
                className="page-link"
                onClick={() =>
                  setPage((p) => Math.max(p - 1, 1))
                }
              >
                Previous
              </button>
            </li>

            {Array.from(
              { length: Math.min(5, pageCount) },
              (_, i) => (
                <li
                  key={i + 1}
                  className={`page-item ${page === i + 1 && "active"
                    }`}
                >
                  <button
                    className="page-link"
                    onClick={() => setPage(i + 1)}
                  >
                    {i + 1}
                  </button>
                </li>
              )
            )}

            {pageCount > 5 && (
              <>
                <li className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => setPage(pageCount)}
                  >
                    {pageCount}
                  </button>
                </li>
              </>
            )}

            <li
              className={`page-item ${page === pageCount && "disabled"
                }`}
            >
              <button
                className="page-link"
                onClick={() =>
                  setPage((p) => Math.min(p + 1, pageCount))
                }
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
      </Paper>
    </div>
  );
};

export default FuelList;

